import { GONKA_CHAIN } from './config.js';
const BOOSTER_TIMEOUT_MS = 2_000;
export function createBalanceReader(client, boosterUrl) {
    async function fromRpc(address) {
        const [totalRes, spendableRes] = await Promise.all([
            client.getApi(`/cosmos/bank/v1beta1/balances/${address}`),
            client.getApi(`/cosmos/bank/v1beta1/spendable_balances/${address}`),
        ]);
        const totalEntry = totalRes.balances.find((b) => b.denom === GONKA_CHAIN.denom.base);
        const spendableEntry = spendableRes.balances.find((b) => b.denom === GONKA_CHAIN.denom.base);
        const total = totalEntry?.amount ?? '0';
        const spendable = spendableEntry?.amount ?? '0';
        const vesting = (BigInt(total) - BigInt(spendable)).toString();
        return {
            total,
            spendable,
            vesting,
            available: spendable,
            source: 'rpc',
            lastUpdated: new Date().toISOString(),
        };
    }
    async function fromBooster(address) {
        const ctrl = new AbortController();
        const timeout = setTimeout(() => ctrl.abort(), BOOSTER_TIMEOUT_MS);
        try {
            const res = await fetch(`${boosterUrl}/balance/${address}`, {
                signal: ctrl.signal,
                headers: { Accept: 'application/json' },
            });
            if (!res.ok) {
                throw new Error(`booster HTTP ${res.status}`);
            }
            const body = (await res.json());
            return {
                total: body.available,
                spendable: body.available,
                vesting: '0',
                available: body.available,
                source: 'booster',
                lastUpdated: new Date().toISOString(),
            };
        }
        finally {
            clearTimeout(timeout);
        }
    }
    return {
        async get(address) {
            if (boosterUrl) {
                try {
                    return await fromBooster(address);
                }
                catch {
                    return fromRpc(address);
                }
            }
            return fromRpc(address);
        },
    };
}
//# sourceMappingURL=balance.js.map